import { render, staticRenderFns } from "./MarryPlan.vue?vue&type=template&id=2d60c3f0&scoped=true"
import script from "./MarryPlan.vue?vue&type=script&lang=js"
export * from "./MarryPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d60c3f0",
  null
  
)

export default component.exports